export default {
    questions: [],
    quizzes: [],
    quiz: null,
    titleTranslation: [],
    titleTranslationId: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/quiz/state.js